import superagent from 'superagent';

function genericXhrHeadersWithCsrf() {
    const csrfMeta = document.querySelector('meta[name="csrf-token"]');
    const token = csrfMeta ? csrfMeta.getAttribute('content') : 'fake-token';
    return {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-Token': token,
    };
}

function genericXhrHeaders() {
    return {
        'X-Requested-With': 'XMLHttpRequest',
    };
}

export function fetchHtml(url: string) {
    return new Promise((resolve, reject) => {
        const xhr = superagent.get(url).set('Accept', 'application/html');

        xhr.end((error, res) => {
            if (error) {
                reject({ error, url });
            } else {
                resolve(res.text);
            }
        });
    });
}

export function get(url: string) {
    return superagent.get(url).set(genericXhrHeaders());
}

export function postRequest(url: string) {
    return superagent.post(url).set(genericXhrHeadersWithCsrf());
}

export function putRequest(url: string) {
    return superagent.put(url).set(genericXhrHeadersWithCsrf());
}

export function deleteRequest(url: string) {
    return superagent.delete(url).set(genericXhrHeadersWithCsrf());
}

export function toggleRequest(toggleState: boolean, url: string) {
    if (toggleState) {
        return putRequest(url);
    }
    return deleteRequest(url);
}



// WEBPACK FOOTER //
// ./src/js/utils/xhr.ts